import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Form, Input } from "antd";
import { useFormTcfVendor } from "../../../../../contexts/formTcfVendor.js";
import { useI18n } from "../../../../../contexts/i18n.js";
const FormTcfVendorFieldGeneralPrivacyPolicyUrl = ()=>{
    const { __ } = useI18n();
    const { vendor: { urls } } = useFormTcfVendor();
    const { privacy, legIntClaim } = urls?.[0] || {
        langId: "",
        privacy: "",
        legIntClaim: ""
    };
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Form.Item, {
                label: __("Privacy policy of the provider"),
                children: /*#__PURE__*/ _jsx(Input, {
                    value: privacy,
                    readOnly: true
                })
            }),
            /*#__PURE__*/ _jsx(Form.Item, {
                label: __("Explanation of the legitimate interest"),
                children: /*#__PURE__*/ _jsx(Input, {
                    value: legIntClaim,
                    readOnly: true
                })
            })
        ]
    });
};
export { FormTcfVendorFieldGeneralPrivacyPolicyUrl };
